import { Contest } from '../../public/contest';
import { FETCH_ONGOING_CONTEST_REQUEST, FETCH_ONGOING_CONTEST_SUCCESS, FETCH_ONGOING_CONTEST_FAILURE } from '../../public/contest/constants';
import { CommonError } from '../../types';
import { CANCEL_REGISTRATION_FAILURE, CANCEL_REGISTRATION_REQUEST, CANCEL_REGISTRATION_SUCCESS, FETCH_PARTICIPANT_BY_ID_FAILURE, FETCH_PARTICIPANT_BY_ID_REQUEST, FETCH_PARTICIPANT_BY_ID_SUCCESS, FETCH_PARTICIPANTS_BY_ID_FAILURE, FETCH_PARTICIPANTS_BY_ID_REQUEST, FETCH_PARTICIPANTS_BY_ID_SUCCESS, REGISTER_CONTEST_FAILURE, REGISTER_CONTEST_REQUEST, REGISTER_CONTEST_SUCCESS } from './constants';
import { ContestParticipant } from './types';
//register contest
export interface RegisterContestRequestAction {
    type: typeof REGISTER_CONTEST_REQUEST;
    payload: Contest;
}

export interface RegisterContestSuccessAction {
    type: typeof REGISTER_CONTEST_SUCCESS;
    payload: ContestParticipant;
}

export interface RegisterContestFailureAction {
    type: typeof REGISTER_CONTEST_FAILURE;
    payload: CommonError;
}
//fetch my participant with contest id
export interface FetchParticipantRequestAction {
    type: typeof FETCH_PARTICIPANT_BY_ID_REQUEST;
    payload: number; 
}

export interface FetchParticipantSuccessAction {
    type: typeof FETCH_PARTICIPANT_BY_ID_SUCCESS;
    payload: ContestParticipant | null;
}

export interface FetchParticipantFailureAction {
    type: typeof FETCH_PARTICIPANT_BY_ID_FAILURE;
    payload: CommonError;
}
//fetch participants of a contest
export interface FetchParticipantsRequestAction {
    type: typeof FETCH_PARTICIPANTS_BY_ID_REQUEST;
    payload: number;
}

export interface FetchParticipantsSuccessAction {
    type: typeof FETCH_PARTICIPANTS_BY_ID_SUCCESS;
    payload: ContestParticipant[];
}

export interface FetchParticipantsFailureAction {
    type: typeof FETCH_PARTICIPANTS_BY_ID_FAILURE;
    payload: CommonError;
}
//cancel registration
export interface CancelRegistrationRequestAction {
    type: typeof CANCEL_REGISTRATION_REQUEST;
    payload: Contest;
}
export interface CancelRegistrationSuccessAction {
    type: typeof CANCEL_REGISTRATION_SUCCESS;
    payload:boolean;
}
export interface CancelRegistrationFailureAction {
    type: typeof CANCEL_REGISTRATION_FAILURE;
    payload: CommonError;
}

export type ContestParticipantActions =
    | RegisterContestRequestAction
    | RegisterContestSuccessAction
    | RegisterContestFailureAction
    | FetchParticipantRequestAction
    | FetchParticipantSuccessAction
    | FetchParticipantFailureAction
    | FetchParticipantsRequestAction
    | FetchParticipantsSuccessAction
    | FetchParticipantsFailureAction
    | CancelRegistrationRequestAction
    | CancelRegistrationSuccessAction
    | CancelRegistrationFailureAction;
//register contest
export const registerContestRequest = (payload:Contest): RegisterContestRequestAction => ({
    type: REGISTER_CONTEST_REQUEST,
    payload: payload,
});

export const registerContestSuccess = (contestParticipant: ContestParticipant): RegisterContestSuccessAction => ({
    type: REGISTER_CONTEST_SUCCESS,
    payload: contestParticipant,
});

export const registerContestFailure = (error: CommonError): RegisterContestFailureAction => ({
    type: REGISTER_CONTEST_FAILURE,
    payload: error,
});
//fetch my participant with contest id
export const fetchParticipantRequest = (payload: number): FetchParticipantRequestAction => ({
    type: FETCH_PARTICIPANT_BY_ID_REQUEST,
    payload,
});

export const fetchParticipantSuccess = (contestParticipant: ContestParticipant): FetchParticipantSuccessAction => ({
    type: FETCH_PARTICIPANT_BY_ID_SUCCESS,
    payload: contestParticipant,
});

export const fetchParticipantFailure = (error: CommonError): FetchParticipantFailureAction => ({
    type: FETCH_PARTICIPANT_BY_ID_FAILURE,
    payload: error,
});
//fetch participants of a contest
export const fetchParticipantsRequest = (payload: number): FetchParticipantsRequestAction => ({
    type: FETCH_PARTICIPANTS_BY_ID_REQUEST,
    payload,
});

export const fetchParticipantsSuccess = (contestParticipants: ContestParticipant[]): FetchParticipantsSuccessAction => ({
    type: FETCH_PARTICIPANTS_BY_ID_SUCCESS,
    payload: contestParticipants,
});

export const fetchParticipantsFailure = (error: CommonError): FetchParticipantsFailureAction => ({
    type: FETCH_PARTICIPANTS_BY_ID_FAILURE,
    payload: error,
});
//cancel registration
export const cancelRegistrationRequest = (payload: Contest): CancelRegistrationRequestAction => ({
    type: CANCEL_REGISTRATION_REQUEST,
    payload,
});

export const cancelRegistrationSuccess = (payload:boolean): CancelRegistrationSuccessAction => ({
    type: CANCEL_REGISTRATION_SUCCESS,
    payload,
});

export const cancelRegistrationFailure = (error: CommonError): CancelRegistrationFailureAction => ({
    type: CANCEL_REGISTRATION_FAILURE,
    payload: error,
});